import {
  loadJSON
} from './getJSON';
import Mustache from 'mustache';

let eventsURL = window.location.pathname;
if (eventsURL == '/about/events/') {
loadJSON('https://apps.library.vcu.edu/pub_scripts/php/libevents.php',
  data => {
    if (data.length == 0) {
      return;
    }
    console.log("we shouldn't be here");
    $.get('https://apps.library.vcu.edu/pub_scripts/js/templates/events.html', function (template) {
      var events = $('.container-secondary--events');
      var rendered = Mustache.render(template, {
        events: data.events
      });
      events.append(rendered);
    })
  });
}